import React, { useState } from 'react';
import Tabs from '../../components/Tabs';
import { ExecuteTabPanel } from '../../views/settlementCompleteDateAdjustment/components/ExecuteTabPanel/ExecuteTabPanel';
import { HistoryTabPanel } from '../../views/settlementCompleteDateAdjustment/components/HistoryTabPanel/HistoryTabPanel';

type TabKey = 0 | 1;

const TAB_LIST = [
  { id: 0 as TabKey, title: '변경 작업 실행' },
  { id: 1 as TabKey, title: '이력 / 롤백' },
];

/**
 * 정산 완료일 변경 컨테이너. 탭 state 만 관리하고 각 패널로 위임.
 * 기준일 변경 도메인의 컨테이너와 동일한 구조이지만 도메인 패널이 다르다.
 */
export const SettlementCompleteDateAdjustmentContainer = (): React.JSX.Element => {
  const [activeKey, setActiveKey] = useState<TabKey>(0);

  const tabList = TAB_LIST.map((tab) => ({
    id: tab.id,
    title: tab.title,
    content:
      tab.id === 0 ? (
        <ExecuteTabPanel onExecuteSuccess={() => setActiveKey(1)} />
      ) : (
        <HistoryTabPanel />
      ),
  }));

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key: number) => setActiveKey(key as TabKey)}
      list={tabList}
    />
  );
};
